import { getAllSettlement } from 'actions/admin';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import MUIDataTable from "mui-datatables";
import Button from '@mui/material/Button';
import customHead from 'constants/customHead';
import ButtonGroup from '@mui/material/ButtonGroup';
import debounce from 'lodash.debounce';
import { useNavigate } from 'react-router';
import Pagination from '@mui/material/Pagination';
import PaginationCount from 'app/routes/components/PaginationCount';
import CircularProgress from '@mui/material/CircularProgress';
import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup } from '@mui/material';
import AppConfig from 'constants/config';
import axios from 'constants/axios';
import { NotificationManager } from 'react-notifications';

function Settlement(props) {
  const history = useNavigate()
  let date = new Date()
  const [dataSellerwiseStatus, setDataSellerwiseStatus] = useState({})
  const [prevDownloadList, SetPrevDownloadList] = useState({})
  const [allSellersCsv, setAllSellersCsv] = useState(false)
  const [state, setState] = useState({
    data: [],
    page: 0,
    perPage: 50,
    value: 0,
    month: date.getMonth(),
    year: date.getFullYear(),
    searchedText: '',
    allChecked: false,
    settleArr: [],
    openDownloadList: false,
    openPrevList: false
  })
  let { month, year, file } = state;

  const handleCloseDownloadPopup = () => {
    setState((prev) => ({
      ...prev,
      openDownloadList: false
    }));
  }
  const resetEverything = async () => {
    setState((prev) => ({
      ...prev,
      allChecked: false,
      settleArr: [],
      openDownloadList: false,
      openPrevList: false
    }));
  };
  const fetchSellerwiseStatus = async () => {
    try {
      const result = await axios.get('/settlements/listGroupSettlementOutside', {
        headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('admin_token')
        },
      });
      if (result.data.error) {
        NotificationManager.error(result.data.title);
      } else {
        // setDataFromParent(result.data.detail);
        setDataSellerwiseStatus(result.data)
      }
    } catch (error) {
      NotificationManager.error('Something went wrong, Please try again', error);
    }
  }
  const fetchPrevDownloadList = async () => {
    try {
      const result = await axios.get('/settlements/prevDownloadList', {
        headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('admin_token')
        },
      });

      if (result.data.error) {
        NotificationManager.error(result.data.title);
      } else {
        // setDataFromParent(result.data.detail);
        SetPrevDownloadList(result.data.data)
      }
    } catch (error) {
      NotificationManager.error('Something went wrong, Please try again', error);
    }
  }
  const handleClosePrevListPopup = () => {
    setState((prev) => ({
      ...prev,
      openPrevList: false
    }));
  }
  const csvSellerwiseSettlement_old = async (sellerIds) => {
    try{
      const sellerIdParam = sellerIds.join(',');
      const token = localStorage.getItem('admin_token');
      const downloadUrl = `${AppConfig.baseUrl}settlements/csvSellerwiseSettlement?sellerIds=${sellerIdParam}&token=${token}`;
  
      await window.open(downloadUrl, '_blank');
      await resetEverything()
      await fetchSellerwiseStatus()
    }catch(err){
      console.log(err)
    }
  };
  const csvSellerwiseSettlement = async (sellerIds) => {
    try {
      const sellerIdParam = sellerIds.join(',');
      const token = localStorage.getItem('admin_token');
      const downloadUrl = `${AppConfig.baseUrl}settlements/csvSellerwiseSettlement?sellerIds=${sellerIdParam}&token=${token}`;

      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        responseType: 'blob' // Important for downloading files
      });

      // Check if response contains error in blob
      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        const reader = new FileReader();
        reader.onload = () => {
          const errorData = JSON.parse(reader.result);
          NotificationManager.error(errorData.title || "Something went wrong");
        };
        reader.readAsText(response.data);
      } else {
        // File is valid, trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Sellerwise_Settlement.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      await resetEverything();
      await fetchSellerwiseStatus();
    } catch (err) {
      NotificationManager.error("Failed to download file.");
      console.error(err);
    }
  };
  
  useEffect(() => {
    fetchSellerwiseStatus()
    fetchPrevDownloadList()
    props.getAllSettlement({ page: state.page + 1, perPage: state.perPage }, history)
  }, [])

  const changePage = (page) => {
    let pages = page + 1
    let data = {
      page: pages,
      perPage: state.perPage,
      searchText: state.searchedText,

    }
    props.getAllSettlement({ data })
    setState((prev) => ({ ...prev, page }))

  };

  const getAction = (data) => {
    return <ButtonGroup color="primary" aria-label="outlined primary button group">
      <Button variant="outlined" className={'text-primary'} onClick={(e) => buttonA(data)}>Details</Button>
    </ButtonGroup>
  }
  const buttonA = (data) => {
    console.log('data===', data)
    history(`/admin/settlement/settlementDetails/${data.seller_id._id}`)
  }
  function throttleHandleChange(edata) {
    props.getAllSettlement({ data: edata, history: history })
  }
  const handleSearch = debounce((searchText) => {
    setState((prev) => ({ ...prev, searchedText: searchText, page: 0 }))
    let data = {
      page: 1,
      perPage: state.perPage,
      searchText: searchText,
    }
    throttleHandleChange(data)
  }, 500)

  const { allSettlement } = props;

  const allCheckbox = () => {
    // Check if all statusSellerIds are present in pendingSellerIds allSellersPending
    const count = allSettlement && allSettlement.data[0] && allSettlement.data[0].metadata[0] && allSettlement.data[0].metadata[0].total
    const allPresent = (count === dataSellerwiseStatus?.data?.length);
    return (
      <Checkbox
        checked={state.allChecked}
        onChange={() => allClicked()}
        disabled={!allPresent}
        color="primary"
        inputProps={{ 'aria-label': 'primary checkbox' }}
      />
    );
  };

  const columns = [
    {
      name: " ",
      label: allCheckbox(),
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => {
          return customHead(o, updateDirection);
        }
      }
    },
    {
      name: "Seller",
      label: "Seller",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => {
          return customHead(o, updateDirection);
        }
      }
    },
    {
      name: "TotalEarning",
      label: "Total Earning",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => {
          return customHead(o, updateDirection);
        }
      }
    },
    {
      name: "PendingAmount",
      label: "Pending Amount",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => {
          return customHead(o, updateDirection);
        }
      }
    },
    {
      name: "SettledAmount",
      label: "Settled Amount",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => {
          return customHead(o, updateDirection);
        }
      }
    },
    {
      name: "Actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => {
          return customHead(o, updateDirection);
        }
      }
    }
  ]
  const options = {
    searchPlaceholder: 'Press Enter to Search',
    filterType: 'dropdown',
    responsive: 'scroll',
    viewColumns: false,
    selectableRows: false,
    page: state.page,
    rowsPerPage: 50,
    fixedHeader: false,
    print: false,
    download: false,
    filter: false,
    sort: false,
    serverSide: true,
    count: allSettlement && allSettlement.data[0] && allSettlement.data[0].metadata[0] && allSettlement.data[0].metadata[0].total,
    server: true,
    selectableRowsOnClick: false,
    search: true,
    searchText: state.searchedText,
    rowsPerPageOptions: [],
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page);
          break;
        case 'search':
          onkeypress = (e) => {
            if (e.key === 'Enter') {
              handleSearch(tableState.searchText)
            }
          }
          break;
        case 'onSearchClose':
          handleSearch();
          break;
        default:
          break;
      }
    },
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return <div className="p-4 d-flex justify-content-end">
        <PaginationCount page={page} rowsPerPage={rowsPerPage} count={count}/>
        <Pagination count={Math.ceil(count / rowsPerPage)} page={page + 1} onChange={(e, page) => { changePage(page - 1) }} color="primary" />
      </div>
    },
    customToolbar: () => {
      return (
        <>
          <Button variant="outlined" disabled={!(allSellersCsv || state.settleArr.length > 0)} color="primary" onClick={(e) => {setState((prev) => ({ ...prev, openDownloadList: true}))}}>
          Download
        </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            variant="outlined"
            color="success"
            disabled={!prevDownloadList.length >0}
            onClick={(e) => {
              setState((prev) => ({ ...prev, openPrevList: true }));
              fetchPrevDownloadList();
            }}
          >
            Recent Downloads
          </Button>
        </>
      );
    }
  }

  const checkBox = (data, isPending) => {
    return <div style={{ display: 'flex' }}>
      <Checkbox
        name='chk'
        onClick={() => setState((prev) => ({
          ...prev, allChecked: false
        }))}
        disabled={!isPending}
        checked={state.allChecked === true ? true : state.settleArr.findIndex(value => value._id == data._id) > -1 ? true : false}
        onChange={() => handleChangeSettle(data)}
        color='primary'
        inputProps={{ 'aria-label': 'primary checkbox' }}
      />
    </div>
  };

  let data1 = [];
  allSettlement && allSettlement.data[0] && allSettlement.data[0].data.map((dataOne, index) => {
    const isPending = Array.isArray(dataSellerwiseStatus?.data)
      ? dataSellerwiseStatus?.data.some(
        status => status._id === dataOne._id && status.hasPending === true
      )
      : false;
    data1.push({
      " ": checkBox(dataOne, isPending),
      Seller: dataOne.seller_id.company_name,
      TotalEarning: <div>₹ {(dataOne.total_amount).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>,
      PendingAmount: <div>₹ {(dataOne.pending_amount).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>,
      SettledAmount: <div>₹ {(dataOne.settled_amount).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>,
      Actions: getAction(dataOne),
    });
  });

  const allClicked = () => {
    setState((prev) => {
      const newChecked = !prev.allChecked;

      const updatedSettleArr = newChecked ? dataSellerwiseStatus?.data || [] : [];

      setAllSellersCsv(newChecked);

      return {
        ...prev,
        settleArr: updatedSettleArr,
        allChecked: newChecked
      };
    });
  };
  
  const handleChangeSettle = (data) => {
    let temp = [...state.settleArr];
    let index = temp.findIndex(d => d._id === data._id);
    
    if (index > -1) {
      temp.splice(index, 1);
    } else {
      temp.push(data);
    }
  
    setState((prev) => ({
      ...prev,
      settleArr: temp,
      allChecked: false
    }));
  };

  const Submit = () => {
    let sellerIds = []
    if (state.settleArr){
      state.settleArr.map((val, id)=>{
        sellerIds.push(val._id)
      })
      csvSellerwiseSettlement(sellerIds)
    }
    setState((prev) => ({...prev,openDownloadList: false,settleArr: []}));
    fetchPrevDownloadList()
  }
  const prevCsvDownload = (fileId) => {
    const token = localStorage.getItem('admin_token');
    const downloadUrl = `${AppConfig.baseUrl}settlements/prevCsvDownload?fileId=${fileId}&token=${token}`;

    window.open(downloadUrl, '_blank');
    setState((prev) => ({ ...prev, openPrevList: false }));
  };

    const prevCsvDownloadtxt = (fileId) => {
    const token = localStorage.getItem('admin_token');
    const downloadUrl = `${AppConfig.baseUrl}settlements/prevCsvDownload_txt?fileId=${fileId}&token=${token}`;

    window.open(downloadUrl, '_blank');
    setState((prev) => ({ ...prev, openPrevList: false }));
  };
  return (
    <React.Fragment>
      {props.loading ? <div className="loader-view"
        style={{ height: props.width >= 1200 ? 'calc(100vh - 259px)' : 'calc(100vh - 238px)' }}>
        <CircularProgress />
      </div> : null}
      {
        props.loading === true ?
          null :
          <MUIDataTable
            title=''
            data={data1}
            columns={columns}
            options={options}
          />
      }
      <Dialog open={state.openDownloadList} onClose={(e) => handleCloseDownloadPopup()} fullWidth={true} maxWidth={'sm'}>
          <DialogTitle className='pb-0'>
            CSV Report for Sellers:
          </DialogTitle>
          <DialogContent>
          <div className="overflow-x-auto mt-2">
            {
              !allSellersCsv ? (
                <div>
                  {state.settleArr.map((seller, index) => (
                    <span key={index} className="text-sm text-gray-800">
                      {seller?.seller_id?.company_name}
                      {index === state.settleArr.length - 1 ? '.' : ', '}
                    </span>
                  ))}
                </div>
              ) : (
                <div className="bg-white border-b">
                  <h5 className="px-4 py-2 text-sm text-gray-800">All the sellers are selected!</h5>
                </div>
              )
            }
          </div>
          <DialogActions className='pt-0'>
            <Button onClick={(e) => handleCloseDownloadPopup()} color='secondary' >
              Close
            </Button>
            <Button onClick={(e) => Submit()} color='primary' >
              Download
            </Button>
          </DialogActions>
          </DialogContent>
      </Dialog>
            {/* open prev 10 download list */}
      <Dialog open={state.openPrevList} onClose={(e) => handleClosePrevListPopup()} fullWidth={true} maxWidth={'sm'}>
        <DialogTitle className='pb-0'>
          Recent Downloaded Settlements:
        </DialogTitle>
        <DialogContent>
          <div className="overflow-x-auto mt-2">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">File Name</th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Downloaded By</th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Download</th>
                </tr>
              </thead>
              <tbody>
                {prevDownloadList.length > 0? prevDownloadList?.map((item, index) => (
                  <tr key={index} className="bg-white border-b">
                    <td className="px-4 py-2 text-sm text-gray-800">{item?.fileName}</td>
                    <td className="px-4 py-2 text-sm text-gray-800">{item?.downloaded_by}</td>
                    <td className="px-4 py-2">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => prevCsvDownload(item?._id)}
                      >
                        .xlsx
                      </Button>
                    </td>
                    <td className="px-0 py-2">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => prevCsvDownloadtxt(item?._id)}
                      >
                        .txt
                      </Button>
                    </td>
                  </tr>
                )): ""}
              </tbody>
            </table>
          </div>
          <DialogActions className='pt-0'>
            <Button onClick={(e) => handleClosePrevListPopup()} color='secondary' >
              Close
            </Button>
          </DialogActions>

        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

const mapStateToProps = ({ admin }) => {
  const { allSettlement, loading } = admin;
  return { allSettlement, loading }
};

export default connect(mapStateToProps, { getAllSettlement })(Settlement);